import {Component} from '@angular/core';
import {ConfirmDialogService} from "./ConfirmDialog.service";


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  standalone: false
})
export class ConfirmDialogComponent {
  title: string = '';
  message: string = '';

  constructor(private readonly confirmDialogService: ConfirmDialogService) {
  }

  onAccept() {
    this.confirmDialogService.confirm();
  }

  onDecline() {
    this.confirmDialogService.cancel();
  }
}
